﻿export const kgToOunces = (k) => k * 35.2739619;

export const kgToPounds = (k) => k * 2.20462;

export const poundsTokg = (p) => p / 2.20462;

export const litersToOunces = (l) => l / 0.0295735;

export const ouncesToLiters = (o) => o * 0.0295735;

export const litersToGallons = (l) => litersToOunces(l) / 128;

export const fahrenheitToCelsius = (f) => round((f - 32) * 5 / 9, 1);

export const celsiusToFahrenheit = (c) => round(c * 1.8 + 32, 1);

export const kpaToPsi = (kpa) => kpa * 0.14503773773020923;

export const psiTokpa = (psi) => psi * 6.894757293168361;

export const sgToPlato = (sg) => -668.962 + 1262.45 * sg - 776.43 * Math.pow(sg, 2) + 182.94 * Math.pow(sg, 3);

export const platoTosg = (e) => 1 + e / (258.6 - e / 258.2 * 227.1);

export const srmToEbc = (srm) => srm * 1.97;

export const ebcToSrm = (ebc) => ebc * 0.508;

export const srmToLovibond = (srm) => (srm + 0.76) / 1.3546;

export const lovibondToSrm = (lovibond) => 1.3546 * lovibond - 0.76;

export const sum = (array) => array.reduce((pv, cv) => pv + cv, 0);

export const round = (number, precision) => Number(Math.round(number + "e" + precision) + "e-" + precision);

export const isEmpty = (value) => (value == null || value.length === 0);


//////////////////
// WEBPACK FOOTER
// ./src/utils/common.js
// module id = 11
// module chunks = 6 7 8